import { render, staticRenderFns } from "./QuestionFormComponent.vue?vue&type=template&id=21074b5d"
import script from "./QuestionFormComponent.vue?vue&type=script&lang=js"
export * from "./QuestionFormComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormComponent.vue?vue&type=style&index=0&id=21074b5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports